import Accordeon from "components/accordeon";
import StyleWrapper, {
    StyleContentWrapper,
    StyleTitlePage,
    StyleAccordeonWrapper,
} from "./style";

export default ({setIsModalOpen}) => {
        
    const faqQuestions = [
        {
            title: "Qual o período de participação da promoção?",
            content:
                "A promoção acontece de 11 de maio de 2026 a 11 de agosto de 2026.",
        },
        {
            title: "Quem pode participar da promoção?",
            content:
                "Podem participar pessoas físicas, maiores de 18 anos, com CNH válida durante todo o período da promoção, residentes no Brasil e que realizem o Best Drive conforme as regras do regulamento.",
        },
        {
            title: "Como faço para participar?",
            content: (
                <>
                    <p>1. Vá até uma concessionária Volkswagen participante.</p>
                    <p>2. Apresente sua CNH válida.</p>
                    <p>3. O consultor Volkswagen fará seu cadastro com seus dados e foto da CNH.</p>
                    <p>4. Realize o Best Drive (mínimo de 1 km rodado).</p>
                    <p>5. Ao final, responda à pesquisa de satisfação e confirme sua participação na promoção.</p>
                    <p>6. Informe se aceita ou não receber uma proposta comercial.</p>
                </>
            ),
        },
        {
            title: "Existe um tempo mínimo ou máximo para o Best Drive?",
            content:
                "Sim. Para que a participação seja válida: o percurso deve ter no mínimo 1 km rodado; o tempo máximo permitido é de 1h30.",
        },
        {
            title: "Quantos números da sorte eu recebo?",
            content: (
                <p>
                    Cada participante tem direito a 1 número da sorte por CPF, independentemente da quantidade de Best Drives realizados.
                </p>
            ),
        },
        {
            title: "Preciso me cadastrar em algum site?",
            content:
                "Não. O cadastro é feito exclusivamente pelo consultor Volkswagen na concessionária participante.",
        },
        {
            title: "Onde consulto meu número da sorte?",
            content:
                "Seu número da sorte poderá ser consultado no site www.bestdrivepremiadovw.com.br utilizando o CPF informado no momento do cadastro.",
        },
        {
            title: "Como funciona o sorteio?",
            content:
                "O sorteio será baseado na extração da Loteria Federal do dia 02 de setembro de 2026. Serão contemplados 3 participantes.",
        },
        {
            title: "Qual é o prêmio da promoção?",
            content:
                "Cada ganhador receberá 1 veículo Volkswagen T-Cross Sense com pacote Seleção, na cor Azul Norway.",
        },
        {
            title: "Como sei se fui um dos ganhadores?",
            content:
                "Os vencedores serão divulgados em até 30 dias após a apuração no site www.bestdrivepremiadovw.com.br e no Instagram oficial da Volkswagen do Brasil (@vwbrasil). Além disso, os contemplados poderão ser contatados por e-mail, WhatsApp ou diretamente pela concessionária responsável pelo Best Drive.",
        },
        {
            title: "Como será feita a entrega do prêmio?",
            content:
                "O veículo será entregue na concessionária Volkswagen mais próxima do endereço informado no cadastro, em até 30 dias após a apuração.",
        },
        {
            title: "Tenho mais dúvidas. Com quem posso falar?",
            content:
                "Entre em contato com a Central de Relacionamento Volkswagen pelo site www.vw.com.br/fale-conosco ou procure a concessionária mais próxima.",
        },
    ];
    return (
        <>
            <StyleWrapper>
                <StyleContentWrapper>
                    <StyleTitlePage>Perguntas frequentes</StyleTitlePage>
                    <StyleAccordeonWrapper>
                        {faqQuestions.map((item, index) => (
                            <Accordeon
                                title={item.title}
                                groupName="faqquestion"
                                index={index}
                                key={`faqquestion${index}`}
                            >
                                {item.content}
                            </Accordeon>
                        ))}
                    </StyleAccordeonWrapper>
                    <div>
                        <p>
                            Período de participação: de 11/05/2026 a 11/08/2026.
                            Serão considerados válidos apenas os teste drives realizados nas concessionárias participantes e que atendam aos parâmetros descritos no regulamento, limitado a um prêmio por CPF.
                            Certificado de autorização N.° 04.049765/2026.
                        </p>
                    </div>
                </StyleContentWrapper>
            </StyleWrapper>
        </>
    );
};
